import { createApp } from "vue";
import { getI18nInstance } from "@locales/i18n";
import { usePinia } from "@store";

export const createAppI18n = (component, props) => createApp(component, props).use(getI18nInstance()).use(usePinia());

export const mountComponent = (component, props, selector) => createAppI18n(component, props).mount(selector);
